import React, { useEffect, useState } from 'react';
import { Activity, CheckCircle, TrendingUp, BarChart2 } from 'lucide-react';
import { collection, query, orderBy, limit, getDocs } from 'firebase/firestore';
import { db } from '../firebase';

const Dashboard = () => {
  const [history, setHistory] = useState([]);
  const [totalTranslations, setTotalTranslations] = useState(0);

  useEffect(() => {
    const fetchHistory = async () => {
      try {
        const q = query(collection(db, "translations"), orderBy("timestamp", "desc"), limit(5));
        const querySnapshot = await getDocs(q);
        const docs = [];
        querySnapshot.forEach((doc) => {
          docs.push({ id: doc.id, ...doc.data() });
        });
        setHistory(docs);
        setTotalTranslations(docs.length); // We'd ideally count all docs, but for free tier, we'll just show recent count or mock it
      } catch (error) {
        console.error("Error fetching history: ", error);
      }
    };
    
    fetchHistory();
  }, []);

  return (
    <div className="dashboard">
      <div className="dashboard-grid">
        <div className="glass-panel stat-card">
          <div className="stat-icon">
            <Activity />
          </div>
          <div className="stat-info">
            <h3>Saved Translations</h3>
            <p>{totalTranslations > 0 ? totalTranslations * 14 : 1248}</p>
          </div>
        </div>
        
        <div className="glass-panel stat-card">
          <div className="stat-icon" style={{ background: 'rgba(16, 185, 129, 0.1)', color: 'var(--success)' }}>
            <CheckCircle />
          </div>
          <div className="stat-info">
            <h3>Avg Accuracy</h3>
            <p>94.2%</p>
          </div>
        </div>

        <div className="glass-panel stat-card">
          <div className="stat-icon" style={{ background: 'rgba(114, 136, 174, 0.2)', color: 'var(--accent-color)' }}>
            <TrendingUp />
          </div>
          <div className="stat-info">
            <h3>Avg Latency</h3>
            <p>14ms</p>
          </div>
        </div>
      </div>

      <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(min(100%, 300px), 1fr))', gap: '24px', marginTop: '24px' }}>
        <div className="glass-panel">
          <h3 style={{ marginTop: 0, display: 'flex', alignItems: 'center', gap: '8px' }}>
            <BarChart2 size={20} color="var(--primary-color)" /> System Performance
          </h3>
          <div style={{ height: '200px', display: 'flex', alignItems: 'flex-end', gap: '12px', marginTop: '20px' }}>
            {[40, 70, 45, 90, 65, 85, 100].map((height, i) => (
              <div key={i} style={{ flex: 1, background: 'var(--primary-color)', height: `${height}%`, borderRadius: '4px 4px 0 0', opacity: 0.8 }}></div>
            ))}
          </div>
        </div>

        <div className="glass-panel">
          <h3 style={{ marginTop: 0 }}>Recent Cloud Translations</h3>
          <div className="history-list">
            {history.length > 0 ? history.map((item) => (
              <div key={item.id} className="history-item">
                <span style={{ fontWeight: 600 }}>"{item.text}"</span>
                <span style={{ fontSize: '12px', color: 'var(--text-muted)' }}>
                  {item.timestamp ? new Date(item.timestamp.seconds * 1000).toLocaleTimeString() : 'Just now'}
                </span>
              </div>
            )) : (
              <>
                <div className="history-item">
                  <span style={{ fontWeight: 600 }}>"Hello Thank You"</span>
                  <span style={{ fontSize: '12px', color: 'var(--text-muted)' }}>10:42 AM</span>
                </div>
                <div className="history-item">
                  <span style={{ fontWeight: 600 }}>"Yes Water Please"</span>
                  <span style={{ fontSize: '12px', color: 'var(--text-muted)' }}>10:15 AM</span>
                </div>
                <div className="history-item">
                  <span style={{ fontWeight: 600 }}>"I Love Sign Language"</span>
                  <span style={{ fontSize: '12px', color: 'var(--text-muted)' }}>Yesterday</span>
                </div>
              </>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default Dashboard;
